const AvaliacaoEnum = {
    ABERTO: 1,
    INICIAR: 2,
    INICIADA: 3,
    FINALIZADA: 4
};

export default AvaliacaoEnum;
